<!--
 * @Author: your name
 * @Date: 2020-10-27 16:31:00
 * @LastEditTime: 2020-10-27 21:33:32
 * @LastEditors: Please set LastEditors
 * @Description: In User Settings Edit
 * @FilePath: /ShopExpressEdition/src/components/main/Notice.vue
-->
<template>
  <ElCard class="notice">
    <div class="title"><span class="item-icon"></span>公 告</div>
    <div class="notice-content">
      <div class="content-title">{{ content.title }}</div>
      <div class="content-list">
        <p class="item">
          {{ content.one }}<span class="time">{{ content.one_time }}</span>
        </p>
        <p class="item">
          {{ content.two }}<span class="time">{{ content.two_time }}</span>
        </p>
        <p class="item">
          {{ content.three }}<span class="time">{{ content.three_time }}</span>
        </p>
      </div>
    </div>
  </ElCard>
</template>

<script>
export default {
  name: 'Notice',
  data() {
    return {
      content: {}
    };
  },
  async mounted() {
    await this._timeInterval();
  },
  methods: {
    async _timeInterval() {
      await this._getData();
      setTimeout(() => {
        this._timeInterval();
      }, 60000 * 5);
    },

    async _getData() {
      this.content = await this.$http.post('/api/home/index/popularNotice');
    }
  }
};
</script>

<style lang="scss">
.notice {
  margin-left: 8px;
  .el-card__body {
    padding: 10px 15px;
    height: 220px;
    box-sizing: border-box;
    .title {
      font-size: 16px;
      border-bottom: 1px dashed #ededed;
      padding-bottom: 10px;
      margin-bottom: 5px;
      .item-icon {
        width: 12px;
        height: 12px;
        margin-bottom: 2px;
        margin-right: 10px;
        display: inline-block;
        border-radius: 100%;
        background-color: #4b90ff;
        vertical-align: middle;
      }
    }
    .notice-content {
      font-size: 14px;
      .content-title {
        color: #6a6a6a;
        padding: 8px 0;
      }
      .content-list {
        color: #b1b1b1;
        .item {
          margin: 0;
          border-top: 1px dashed #ededed;
          padding-top: 15px;
          padding-bottom: 8px;
          &:first-child {
            border-top: 0;
          }
          .time {
            float: right;
          }
        }
      }
    }
  }
}
</style>
